var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 5,
    transform: "matrix(-1 0 0 1 28 0)",
    fill: "#2820DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.00159C10.0002 7.26702 10.1072 7.52149 10.2972 7.70906L15.4802 12.8295C15.6371 12.9845 15.7616 13.1684 15.8465 13.3709C15.9314 13.5734 15.9751 13.7904 15.9751 14.0095C15.9751 14.2287 15.9314 14.4457 15.8465 14.6482C15.7616 14.8506 15.6371 15.0346 15.4802 15.1896L10.304 20.3034C10.1194 20.4922 10.0173 20.7451 10.0196 21.0076C10.0219 21.2701 10.1285 21.5212 10.3163 21.7068C10.5042 21.8924 10.7584 21.9977 11.0241 22C11.2898 22.0022 11.5458 21.9013 11.7369 21.719L16.9131 16.6092C17.6091 15.9202 18 14.9866 18 14.0132C18 13.0398 17.6091 12.1062 16.9131 11.4173L11.7301 6.29345C11.5884 6.15335 11.4078 6.05793 11.2112 6.01926C11.0145 5.9806 10.8107 6.00042 10.6255 6.07623C10.4403 6.15204 10.282 6.28043 10.1706 6.44515C10.0593 6.60987 9.99991 6.80352 10 7.00159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrowRight);
export default __webpack_public_path__ + "static/media/PaginationArrowRight.0530a95714ec9603516218ff830807d1.svg";
export { ForwardRef as ReactComponent };